import React from 'react';
import { useSelector } from 'react-redux';

export const TypingIndicator = ({ chatId, participants, currentUserId }) => {
    const typingUsers = useSelector((state) => state.chat.typingUsers[chatId]) || [];

    const filteredTyping = typingUsers.filter((u) => u.userId !== currentUserId);

    if (!filteredTyping.length) return <div className="chat-typing-container" />;

    // Resolve names for all typing users
    const typingNames = filteredTyping.map((t) => {
        const participant = participants?.find((p) => p.userId === t.userId);
        return participant?.user?.firstName || 'Someone';
    });

    // Build display text: "Alice is typing", "Alice and Bob are typing", "Alice, Bob, and 1 other are typing"
    let typingText;
    if (typingNames.length === 1) {
        typingText = `${typingNames[0]} is typing`;
    } else if (typingNames.length === 2) {
        typingText = `${typingNames[0]} and ${typingNames[1]} are typing`;
    } else {
        const othersCount = typingNames.length - 2;
        typingText = `${typingNames[0]}, ${typingNames[1]}, and ${othersCount} ${othersCount === 1 ? 'other is' : 'others are'} typing`;
    }

    // Show first typing user's avatar
    const firstTyping = filteredTyping[0];
    const participant = participants?.find((p) => p.userId === firstTyping.userId);
    const avatar = participant?.user?.avatar || null;
    const name = participant?.user?.firstName || 'Someone';
    const initials = participant?.user
        ? `${participant.user.firstName?.[0] || ''}${participant.user.lastName?.[0] || ''}`.toUpperCase()
        : '?';

    return (
        <div className="chat-typing-container">
            <div className="chat-typing-avatar-col">
                {avatar ? (
                    <img
                        src={avatar}
                        alt={name}
                        style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                        }}
                    />
                ) : (
                    <div
                        style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '50%',
                            background: '#E4E7EC',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '10px',
                            fontWeight: '600',
                            color: '#344054',
                        }}
                    >
                        {initials}
                    </div>
                )}
            </div>
            <div>
                <div className="chat-typing-name">{typingText}</div>
                <div className="chat-typing-dots-wrapper">
                    <div className="chat-typing-dot" />
                    <div className="chat-typing-dot" />
                    <div className="chat-typing-dot" />
                </div>
            </div>
        </div>
    );
};
